// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/buttonscontrol.scss
// module id = 359
// module chunks = 2